import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject, Component, OnInit } from '@angular/core';

@Component({
  selector: 'xsr-select-declined-reason-dialog',
  templateUrl: './select-declined-reason-dialog.component.html',
  styleUrls: ['./select-declined-reason-dialog.component.css'],
})
export class SelectDeclinedReasonDialogComponent implements OnInit {
  selectedDeclinedReason: any;

  constructor(
    public dialogRef: MatDialogRef<SelectDeclinedReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close({ cancelled: true, selectedDeclinedReason: null });
  }

  onConfirm(selectedDeclinedReason: any): void {
    this.dialogRef.close({ cancelled: false, selectedDeclinedReason: selectedDeclinedReason });
  }
}
